export function exportToCSV(districts) {
  // Defensive check for missing or empty districts
  if (!districts || !Array.isArray(districts) || districts.length === 0) {
    console.warn('No districts to export');
    return;
  }

  const headers = [
    'District',
    'State',
    'Name',
    'Model Rating',
    'Win Probability D (%)',
    'Win Probability R (%)',
    'Competitiveness Score',
    'Confidence Level',
    'Confidence',
    '2024 Margin',
    'PVI',
    'Incumbent',
    'Party',
    'Open Seat',
    'Dem Candidates',
    'Rep Candidates',
    'Filing Deadline'
  ];

  const rows = districts.map(d => {
    const demCount = d.candidates?.filter(c => c.party === 'Democratic').length || 0;
    const repCount = d.candidates?.filter(c => c.party === 'Republican').length || 0;

    // New metrics (from enrichDistricts)
    const winProbD = d.winProbD !== undefined ? (d.winProbD * 100).toFixed(1) : 'N/A';
    const winProbR = d.winProbR !== undefined ? (d.winProbR * 100).toFixed(1) : 'N/A';
    const compScore = d.competitivenessScore !== undefined ? d.competitivenessScore : 'N/A';
    const confLabel = d.confidenceLabel || 'N/A';

    return [
      d.district_code || 'N/A',
      d.state || 'N/A',
      `"${d.name || 'N/A'}"`,
      d.model_rating || 'N/A',
      winProbD,
      winProbR,
      compScore,
      confLabel,
      d.model_confidence || 'N/A',
      d.margin_2024 || 'N/A',
      d.pvi || 'EVEN',
      d.incumbent_name || 'N/A',
      d.incumbent_party || 'N/A',
      d.is_open_seat ? 'Yes' : 'No',
      demCount,
      repCount,
      d.filing_deadline || 'N/A'
    ];
  });

  const csv = [
    headers.join(','),
    ...rows.map(row => row.join(','))
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `competitive-districts-${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export function getRatingColor(rating) {
  if (!rating) return 'bg-slate-700/20 text-slate-300 border-slate-600/30';
  if (rating.includes('D')) return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
  if (rating === 'Toss-Up') return 'bg-tossup/20 text-purple-300 border-tossup/30';
  if (rating.includes('R')) return 'bg-red-500/20 text-red-300 border-red-500/30';
  return 'bg-slate-700/20 text-slate-300 border-slate-600/30';
}

export function formatMargin(margin) {
  if (margin === null || margin === undefined) return 'N/A';
  const prefix = margin > 0 ? 'D+' : 'R+';
  return `${prefix}${Math.abs(margin).toFixed(1)}%`;
}
